const IconDiamond = ({ size, color, ...props }) => (
    <svg width={size} height={'13'} viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M14.8633 4.79688L12.0195 0.585938C11.9102 0.394531 11.6914 0.285156 11.5 0.285156H4.47266C4.28125 0.285156 4.0625 0.394531 3.95312 0.585938L1.13672 4.79688C0.945312 5.04297 0.972656 5.39844 1.19141 5.61719L7.50781 12.3438C7.64453 12.4805 7.80859 12.5352 8 12.5352C8.16406 12.5352 8.32812 12.4805 8.46484 12.3438L14.8086 5.61719C15.0273 5.39844 15.0547 5.04297 14.8633 4.79688ZM11.4453 2.0625L13.1953 4.66016H9.36719L11.4453 2.0625ZM8 4.30469L5.83984 1.59766H10.1328L8 4.30469ZM4.52734 2.0625L6.60547 4.66016H2.77734L4.52734 2.0625ZM8 10.9219L3.32422 5.97266H12.6484L8 10.9219Z"
            fill={color}
        />
    </svg>
);

export default IconDiamond;
